import { render } from "./AuthorDetailPage.vue?vue&type=template&id=76f8d0c6&scoped=true&ts=true"
import script from "./AuthorDetailPage.vue?vue&type=script&lang=ts"
export * from "./AuthorDetailPage.vue?vue&type=script&lang=ts"

import "./AuthorDetailPage.vue?vue&type=style&index=0&id=76f8d0c6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f8d0c6"]])

export default __exports__